define(["./selector-sizzle"], function () {});